import { swalAlertPopProps } from "../../utils/commonUtils";
import { addBillCounterSell } from "../counterSellBilling/counterSellBillingApi";

export const addBill = async (
  param,
  addBillCounterSell,
  Swal,
  navigate,
  routePath,
  callback,
) => {
  await addBillCounterSell(param)
    .then((res) => {
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Saved successfully",
          icon: "success",

          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "success",
          ...swalAlertPopProps,
        });
      }
      callback(res);

      navigate(routePath.COUNTERSELL);
    })
    .catch((err) => {
      Swal.fire({
        text: "error ",
        icon: "warning",

        ...swalAlertPopProps,
      });
    });
};

export const updateBil = async (
  param,
  UpdateBillCounterSell,
  Swal,
  navigate,
  routePath,
  callback,
) => {
  await UpdateBillCounterSell(param)
    .then((res) => {
      callback(res);
      // if (res?.data?.succeeded) {
      //   Swal.fire({
      //     text: "Update successfully",
      //     icon: "success",

      //     ...swalAlertPopProps,
      //   });
      // } else {
      //   Swal.fire({
      //     text: res?.data?.message,
      //     icon: "success",
      //     ...swalAlertPopProps,
      //   });
      // }
      // navigate(routePath.COUNTERSELL);
    })
    .catch((err) => {
      Swal.fire({
        text: "error ",
        icon: "warning",

        ...swalAlertPopProps,
      });
    });
};

export const addBillPart = async (
  param,
  addBillPartPayment,
  Swal,
  navigate,
  routePath,
  callback,
) => {
  await addBillPartPayment(param)
    // console.log('part', param)
    .then((res) => {
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Saved successfully",
          icon: "success",

          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "success",
          ...swalAlertPopProps,
        });
      }
      callback(res);

      navigate(routePath.COUNTERSELL);
    })
    .catch((err) => {
      Swal.fire({
        text: "error ",
        icon: "warning",

        ...swalAlertPopProps,
      });
    });
};

export const updateBillPart = async (
  param,
  updateBillPartPayment,
  Swal,
  navigate,
  routePath,
  callback,
) => {
  await updateBillPartPayment(param)
    // console.log('part', param)
    .then((res) => {
      callback(res);

      // navigate(routePath.COUNTERSELL);
    })
    .catch((err) => {
      Swal.fire({
        text: "error ",
        icon: "warning",

        ...swalAlertPopProps,
      });
    });
};
